export enum AgentType {
  Default = 0,
  DirectAgent = 1,
  IndirectAgent = 2,
  BancaStaff = 3,
  BancaNonStaff = 4,
}
